import { fg } from '@atlaskit/platform-feature-flags';

import {
	DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
} from '../../entities';
import { type TypeFilterValue3PEntities, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { TeamsIcon } from './icon';
import { TeamsIconBorderless } from './icon-borderless';
import { TeamsSearchResultIcon } from './search-result-icon';

const getTeamsTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	config.set(TypeFilterValueKey.Conversation, {
		entities3P: [
			...DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
			...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
		],
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.Message, {
		entities3P: DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
		subTypes3P: [],
	});

	if (fg('rovo_fps_enable_ms_teams_meeting_type_filter')) {
		config.set(TypeFilterValueKey.Video, {
			entities3P: DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
			subTypes3P: [],
		});
	}

	if (fg('rovo_fps_enable_ms_teams_attachment_type_filter')) {
		config.set(TypeFilterValueKey.Attachment, {
			entities3P: DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
			subTypes3P: [],
		});
	}

	return config;
};

export const teamsConfig: ThirdPartyConfig = {
	displayName: 'Teams',
	id: 'teams',
	resourceType: 'microsoft-teams-connector',
	icon: get3PLogo(TeamsIcon, 'Teams', 'medium'),
	iconBorderless: get3PLogo(TeamsIconBorderless, 'Teams', 'small'),
	searchResultIcon: get3PLogo(TeamsSearchResultIcon, 'Teams', 'large'),
	integrationAri: 'ari:cloud:platform::integration/microsoft',
	get typeFilterConfig() {
		return getTeamsTypeFilterConfig();
	},
	filters: ['lastUpdated'],
	requiresOauth: true,
	isEnabled: () => true,
};
